export default "__VITE_ASSET__GsX$$eEL__"